var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 0C7.75936 0.000237883 9.99691 2.23769 9.99707 4.99805C9.99707 6.17681 9.08543 8.17224 8.04102 10.0713C6.69258 12.5224 3.30447 12.5224 1.95605 10.0713C0.911645 8.17224 0 6.17681 0 4.99805C0.000162125 2.23754 2.23848 0 4.99902 0ZM4.99805 3.02344C3.90671 3.02347 3.02158 3.90771 3.02148 4.99902C3.02148 6.09042 3.90666 6.97555 4.99805 6.97559C6.08946 6.97559 6.97461 6.09044 6.97461 4.99902C6.97452 3.90768 6.08941 3.02344 4.99805 3.02344Z",
    fill: "#50C8FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerWorker);
export default __webpack_public_path__ + "static/media/marker-worker.eae47d3bff844e98683825f290e53095.svg";
export { ForwardRef as ReactComponent };